import { MobileOnlyLogo } from '@/pages/components/Branding';
import { ContactNurse } from '@/pages/ConsultEligibleNurseForms/ContactNurse';
import { EligibilityVariantImmediateConsult } from '@/pages/ConsultEligibleNurseForms/EligibilityVariantImmediateConsult';
import { NurseConsultation } from '@/pages/ConsultEligibleNurseForms/NurseConsultation';
import type { Step } from '@montugroup/form-builder';

export const getConsultEligibleNurseSteps = (): Step[] => {
  return [
    {
      id: 1,
      type: 'section',
      formTitle: <MobileOnlyLogo />,
      title: '',
      content: [
        {
          type: 'custom',
          component: <EligibilityVariantImmediateConsult />,
        },
      ],
      nextButtonConfig: {
        text: '',
      },
    },
    {
      id: 2,
      type: 'section',
      formTitle: <MobileOnlyLogo />,
      title: '',
      content: [
        {
          type: 'custom',
          component: <ContactNurse />,
        },
      ],
      nextButtonConfig: {
        text: '',
      },
      hideBackButton: true,
    },
    {
      id: 3,
      type: 'section',
      formTitle: <MobileOnlyLogo />,
      title: '',
      content: [
        {
          type: 'custom',
          component: <NurseConsultation />,
        },
      ],
      nextButtonConfig: {
        text: '',
      },
      hideBackButton: true,
    },
  ];
};
